// Public-site palette as CSS variables (defaults in index.css :root, overridden by the published layout).
export const GOLD = 'var(--site-gold)';
export const NAVY = 'var(--site-navy)';
export const CREAM = 'var(--site-bg)';
export const ALT_BG = 'var(--site-bg-alt)';
export const INK = 'var(--site-text)';

// `${GOLD}55`-style hex alpha for CSS variables.
export const alpha = (color, hex) => `color-mix(in srgb, ${color} ${Math.round((parseInt(hex, 16) / 255) * 100)}%, transparent)`;
